import React from 'react'
import { Button, Checkbox, FormControl, FormControlLabel, Grid, InputAdornment, InputLabel, MenuItem, Select, TextField, Tooltip, Typography, Collapse } from '@mui/material'

/**
 * Capitalize first latter
 * @param  value string
 * @returns string
 */
export const capitalize = (value: string): string => value[0].toUpperCase() + value.substring(1, value.length)

/**
 * Takes object and return query values for params data
 * @param values Object
 * @returns string
 */
export const makeQueryParamsString = (values: unknown): string => {
    const availableQueriesString: string = Object.entries(values)
        .map(([key, value]) => (!!value ? `${key}=${value || ''}` : ''))
        .filter(v => v)
        .join('&')
    return !!availableQueriesString ? `?${availableQueriesString}` : ''
}

export const replaceHidenCharsWithSpaces = str => {
    if (typeof str !== 'string') {
        throw new TypeError('Expected a string')
    }
    return str.replace(/\s/g, ' ')
}
